import React, { useLayoutEffect, useState } from 'react';
import { ChevronDown } from '@carbon/icons-react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { colorSet } from '@components/Provider';
import { Spotlight } from '@components/Spotlight';
import useSpotlight from '@components/Spotlight/useSpotlight';
import { TutorialStepProps } from '../CapaViewTutorial';

const TutorialStep1 = ({ handleNextStep }: TutorialStepProps) => {
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const [test, setTest] = useState<HTMLElement | null>();
  const { load, width, height } = useSpotlight();

  useLayoutEffect(() => {
    const $button = document.getElementById('viewer-filelist-button');
    $button?.click();
    setTest(document.getElementById('fake-button-0'));
  }, []);

  return (
    <React.Fragment>
      {load && test && (
        <Spotlight
          cutOutTarget={test}
          radiusSize={50}
          CTATitle={
            <Box display={'flex'} alignItems={'center'}>
              {matches ? (
                <>
                  <ChevronDown color={colorSet.primary500} size={26} />
                  주석달기 클릭
                </>
              ) : (
                <>
                  주석달기 클릭
                  <ChevronDown color={colorSet.primary500} size={26} />
                </>
              )}
            </Box>
          }
          CTADirection={'top'}
          CTADescription={
            matches
              ? '하단의 주석 달기를 통해 도면위 아무곳이나 짚어 주석을 남길 수 있어요.'
              : '하단의 주석 달기를 클릭하면 주석을 달 수 있는 포인터가 생겨요.'
          }
          handleNextStep={() => handleNextStep('2')}
          clientWidth={width}
          clientHeight={height}
          addX={matches ? 95 : 0}
        />
      )}
    </React.Fragment>
  );
};

export default TutorialStep1;
